export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";

export const GET_USER_LOGIN = "GET_USER_LOGIN";
export const GET_USER_LOGIN_DATA = "GET_USER_LOGIN_DATA";

export const LOGOUT = "LOGOUT";

export const SPV_DATA_REQUEST = "SPV_DATA_REQUEST";

export const SPV_CREATE_USER = "SPV_CREATE_USER";
export const SPV_GET_PROJECT = "SPV_GET_PROJECT";

export const SPV_COLUMN_DATA = "SPV_COLUMN_DATA";

export const SPV_UPDATE_STATUS = "SPV_UPDATE_STATUS";

export const SPV_RETURN_WITH_NOTE = "SPV_RETURN_WITH_NOTE";

export const SPV_LENGTH_TASK_LIST = "SPV_LENGTH_TASK_LIST";

export const SPV_MATCH_PROJECT_ID = "SPV_MATCH_PROJECT_ID";

export const SPV_PAGINATION = "SPV_PAGINATION"

export const SPV_OFFSET = "SPV_OFFSET"

export const SPV_GET_NOTIF_TASKLIST = "SPV_GET_NOTIF_TASKLIST"

export const SPV_NOTIF_TASKLIST_SUCCESS = "SPV_NOTIF_TASKLIST_SUCCESS"

export const SPV_NOTIF_TASKLIST_FAILED = "SPV_NOTIF_TASKLIST_FAILED"

export const PLANNER_LENGTH_TASK_LIST = "PLANNER_LENGTH_TASK_LIST";

export const PLANNER_GET_CURRENT_STATUS = "PLANNER_GET_CURRENT_STATUS";

export const PLANNER_MATCH_PROJECT_ID = "PLANNER_MATCH_PROJECT_ID";

export const PLANNER_VALIDATION_DATE_WORKER = "PLANNER_VALIDATION_DATE_WORKER";

export const PLANNER_COLUMN_DATA = "PLANNER_COLUMN_DATA";
export const PLANNER_CREATE_PROJECT = "PLANNER_CREATE_PROJECT";
export const PLANNER_CREATE_TASK = "PLANNER_CREATE_TASK";

